import React, { StrictMode } from 'react';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from 'app/routes';
import Main from './Main';

import EditGeneral from './MemberInfo/Edit/General';
import EditBasic from './MemberInfo/Edit/Basic';
import EditLanguages from './MemberInfo/Edit/Languages';
import EditExperience from './MemberInfo/Edit/Experience';
import EditCareerHistory from './MemberInfo/Edit/CareerHistory';
import EditPassword from './MemberInfo/Edit/Password';

export default function Index() {
  const router = createBrowserRouter([
    {
      path: routes.members.profile.index,
      element: <Main />,
      children: [
        {
          path: routes.members.profile.general,
          element: <EditGeneral />,
        },
        {
          path: routes.members.profile.basic,
          element: <EditBasic />,
        },
        {
          path: routes.members.profile.password,
          element: <EditPassword />,
        },
        {
          path: routes.members.profile.languages,
          element: <EditLanguages />,
        },
        {
          path: routes.members.profile.experience,
          element: <EditExperience />,
        },
        {
          path: routes.members.profile.career_history,
          element: <EditCareerHistory />,
        },
      ],
    },
  ]);

  return (
    <StrictMode>
      <UsersContextProvider>
        <RouterProvider router={router} />
      </UsersContextProvider>
    </StrictMode>
  );
}
